import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../../res/translations/messages';

/* eslint-disable react/jsx-no-bind */

const ImageUpload = ({field, form, ...rest}) => {
    const [src, setSrc] = useState();
    const setValue = (value) => {
        setSrc(value);
        form.setFieldValue(field.name, value);
    };
    const handleChange = ({currentTarget}) => {
        const file = currentTarget.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            setValue(event.target.result);
        };
        reader.readAsDataURL(file);
    };
    return (
        <div className="row image-upload">
            <div className="col-xs-12 col-md-9 mb-3">
                <div className="custom-file">
                    <input onChange={handleChange} {...rest} />
                    <label className="custom-file-label text-truncate" htmlFor={field.id}>
                        <span>
                            <FormattedMessage {...messages.label.chooseImage} />
                        </span>
                        {' '}
                        <span className="d-none d-sm-inline">
                            <FormattedMessage {...messages.label.chooseImageMax} values={{max: constants.UPLOAD_MAX_SIZE_HUMAN}} />
                        </span>
                    </label>
                </div>
            </div>
            <div className="col-xs-12 col-md-3 image-upload-preview">
                {src && <>
                    <img src={src} alt="" className="img-thumbnail" /><br />
                    <a onClick={() => setValue('')}>
                        <FormattedMessage {...messages.label.removeImage} />
                    </a>
                </>}
            </div>
        </div>
    );
};

export default ImageUpload;
